import React, { FC } from "react";
import { TaskCalendarHeader } from "./calendar/components/TaskCalendarHeader";
import { TaskGanttPanel } from "./calendar/components/TaskGanttPanel";
import { TaskScheduleCalendar } from "./calendar/components/TaskScheduleCalendar";
import { useTaskCalendarEvents } from "./calendar/hooks/useTaskCalendarEvents";
import { useTaskCalendarState } from "./calendar/hooks/useTaskCalendarState";
import type { TaskCalendarProps } from "./calendar/types";

export type { CalendarMode } from "./calendar/types";
export { TaskCalendarStatus as Statuses } from "./calendar/types";

const TaskCalendar: FC<TaskCalendarProps> = ({
  onBackClick,
  mode = "executions",
}) => {
  const {
    t,
    viewMode,
    currentPeriod,
    anchorDate,
    range,
    periodOptions,
    viewModeOptions,
    ganttPeriodBounds,
    setAnchorDate,
    setCurrentPeriod,
    handleViewModeChange,
    handleScheduleDatesChange,
  } = useTaskCalendarState();

  const { events } = useTaskCalendarEvents({ mode, range, t });

  return (
    <div className="w-full flex flex-col bg-white text-black overflow-hidden">
      <TaskCalendarHeader
        onBackClick={onBackClick}
        t={t}
        viewMode={viewMode}
        viewModeOptions={viewModeOptions}
        onViewModeChange={handleViewModeChange}
      />

      <div className="flex-1 overflow-y-auto px-6 pb-6">
        {viewMode === "schedule" ? (
          <TaskScheduleCalendar
            events={events}
            t={t}
            fullHeight={Boolean(onBackClick)}
            onDatesChange={handleScheduleDatesChange}
          />
        ) : (
          <TaskGanttPanel
            t={t}
            events={events}
            currentPeriod={currentPeriod}
            anchorDate={anchorDate}
            periodOptions={periodOptions}
            rangeStart={ganttPeriodBounds.start}
            rangeEnd={ganttPeriodBounds.end}
            onPeriodChange={setCurrentPeriod}
            onAnchorDateChange={setAnchorDate}
          />
        )}
      </div>
    </div>
  );
};

export default TaskCalendar;
